var search = {

    $input: $('.search.full .moteurrecherche'),
    $overlay: $('.overlay'),

    minLength: 3,

    timer: null,
    cacheQuery: "",
    highlighted: -1,

    init: function () {
        this.setListeners();
        this.hide();
    },

    setListeners: function () {
        var $this = this;

        // Evènement de déclenchement du scroll
        this.$input.on('focus', function () {
            $('html, body').animate({
                scrollTop: this.offsetTop
            }, 300);
        });


        // Evènement de déclenchement de la requête autosuggest
        this.$input.on('focus input', function () {
            $this.show();

            clearInterval($this.timer);

            $this.timer = setTimeout(function () {
                $this.checkSuggest()
            }, 500);
        });

        // Evènement de déclenchement de la requête autosuggest
        this.$input.on('input', function () {
            if (!$(this).is(':focus')) {
                return;
            }

            $this.$input.toggleClass('filled', $(this).val() !== '');

            // On répercute la valeur du champ sur les autres champs similaires
            // (car ils sont différents à cause du responsive)
            $this.$input.not($(this)).val($(this).val());

            // On place l'URL de redirection en donnée du champ
            $this.$input.data('href', '/s/'+ $(this).val().replace(/\s/g, '+'));
        });

        // Evènement de navigation dans le menu autosuggest
        this.$input.on('keydown', function (event) {
            var key = $this.getKeyCode(event);

            var TAB = 9;
            var ESC = 27;
            var KEYUP = 38;
            var KEYDN = 40;
            var ENTER = 13;
            //if (key > 0)

            switch (key) {
                case ENTER:
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    event.stopPropagation();
                    if ($.trim($(this).val()) !== '') {
                        $this.submitSuggest();
                    }
                    else {
                        $this.hide(true);
                    }
                    break;

                case TAB:
                    $this.hide(true);
                    break;

                case ESC:
                    $this.hide(true);
                    break;

                case KEYUP:
                    event.stopPropagation();
                    $this.highlighted--;
                    $this.changeHighlight();
                    break;

                case KEYDN:
                    event.stopPropagation();
                    $this.highlighted++;
                    $this.changeHighlight();
                    break;
            }
        });

        var $form = this.$input.closest('form');

        $form.find('.back').on('click', function(e) {
            e.preventDefault();
            $this.hide(true);
        });

        $form.find('.cross').on('click', function(e) {
            e.preventDefault();
            $this.$input.filter(':visible')
                .focus()
                .val('')
                .trigger('input');

            $this.hide(true);
        });

        $form.on('submit', function(e) {
            e.preventDefault();
            $this.$input.data('href', '/s/'+ $this.$input.val().replace(/\s/g, '+'));
            $this.submitSuggest();
        });


        $('.search-icon').on('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            var $mobileSearch = $('.mobile-search');
            if (!$mobileSearch.is(':visible')) {
                menu.hideMenu();
                $mobileSearch.slideDown(200)
                    .find('input').focus();
            }
        });


    },



    checkSuggest: function () {
        var inputValue = this.$input.val();
        if (!inputValue || inputValue === this.cacheQuery) {
            return false;
        }

        this.cacheQuery = inputValue;
        this.getSuggestions(inputValue);
    },


    getSuggestions: function (query) {
        var $this = this;

        // Si la longueur du terme est inférieure à la longueur minimale require, on ne déclenche rien,
        // et on cache l'éventuelle fenêtre de suggestion déjà ouverte.
        if (query.length < this.minLength) {
            this._hideSuggest();
            return;
        }


        var result = $.post('/websvc/search-suggestions.ws.php', {
            q: query,
            nocache: Math.random()
        })
            .done(function (data, status, xhr) {
                if (data && data.html) {
                    $('.search .autosuggest-content').html(data.html)
                    $this.show();
                }
            });


    },

    submitSuggest: function () {
        if (this.submitting) {
            return;
        }
        this.submitting = true;

        this.hide();

        window.location.href = this.$input.data('href');
    },

    show: function () {
        this._setAutosuggestPopupListeners();
        this._showOverlay();
        this._showSuggest();
    },

    _showSuggest: function () {
        $('.autosuggest-content').addClass('visible');
        $('.autosuggest-input').addClass('opened');
    },

    _showOverlay: function () {
        var $this = this;
        if (!$this.$overlay.length) {
            return;
        }

        $this.$input.closest('.search').addClass('over-overlay');

        overlay.show();
        // $this.$overlay.css({
        //     'visibility': 'visible',
        //     'opacity': '1'
        // });

        // $('body').on('click.closeOverlay', function (event) {
        //     if (!$(event.target).is('.moteurrecherche')) {
        //         $this.hide();
        //     }
        // });

        // if (isTouchDevice()) {
        //     $this.$overlay.swipe({
        //         tap: function (e) {
        //             $this.hide();
        //         }
        //     });
        // }

    },

    hide: function (force) {
        this._unsetAutosuggestPopupListeners();
        this._hideSuggest();

        if (isTouchDevice() || force || !this.$input.is(':focus')) {
            this._hideOverlay();
        }

        $('.mobile-search').slideUp(200);

    },

    _hideOverlay: function () {
        var $this = this;
        // $('body').off('click.closeOverlay');

        // if (isTouchDevice()) {
        //     $this.$overlay.swipe({
        //         tap: false
        //     });
        // }

        $this.$input.closest('.search').removeClass('over-overlay');
        overlay.hide();
        // $this.$overlay.css({
        //     'visibility': 'hidden',
        //     'opacity': '0'
        // });

        this.$input.blur();
    },

    _hideSuggest: function () {
        clearInterval(this.timer);

        $('.autosuggest-content').removeClass('visible');
        $('.autosuggest-input').removeClass('opened');
    },
    _setAutosuggestPopupListeners: function () {
        var $this = this;

        this._unsetAutosuggestPopupListeners();

        $('.overlay').on('click.closeSearchSuggestion', function() {
            $this.hide();
        });

        // // Evènement de fermeture de la popup autosuggest au clic en dehors de la popup
        // $('body').on('click.closeSearchSuggestion', function (event) {
        //     alert('click');
        //     if ($('.overlay').is(':visible') && $(event.target).closest('.search').length === 0) {
        //         event.preventDefault();
        //         event.stopPropagation();
        //         event.stopImmediatePropagation();
        //         $this.hide();
        //     }
        // });

        $('#navbarNav').on('mouseenter.closeSearchSuggestion', function (event) {
            $this.hide();
        });

        // if (isTouchDevice()) {
        //     $('body').swipe({
        //         tap: function (e) {
        //             if ($(e.target).closest('.search').length === 0) {
        //                 e.preventDefault();
        //                 e.stopPropagation();
        //                 e.stopImmediatePropagation();
        //
        //                 $this.hide();
        //             }
        //         }
        //     });
        // }

    },

    _unsetAutosuggestPopupListeners: function () {
        $('.overlay').off('click.closeSearchSuggestion');
        // $('body').off('click.closeSearchSuggestion');
        $('#navbarNav').off('mouseenter.closeSearchSuggestion');

        // if (isTouchDevice()) {
        //     $('body').swipe({
        //         tap: false
        //     });
        // }

    },

    changeHighlight: function () {
        var $items = $('.autosuggest').find('a');
        var $itemSelected = $items.eq(this.highlighted);

        if (this.highlighted >= $items.length) {
            highlighted = 0;
        }
        if (this.highlighted < 0) {
            this.highlighted = $items.length - 1;
        }

        $items.removeClass('selected');
        $itemSelected.addClass('selected');

        this.$input
            .val($itemSelected[0].title)
            .data('href', $itemSelected[0].href !== '#' ? $itemSelected[0].href : '');

    },


    getKeyCode: function (e) {
        // IE
        if (window.event) {
            return window.event.keyCode;
        }
        // Netscape/Firefox/Opera
        else if (e.which) {
            return e.which;
        }
    }

};

(function ($) {
    search.init();
})(jQuery);

